import React, { ReactNode } from 'react';
import { Divider } from '../../../components/Divider';
import { NoDataMessage } from '../../../components/NoDataMessage';

interface Props<T> {
  items: any[];
  name: string;
  renderRow(item: T, index: number): ReactNode;
}

export function SettingItemList<T>({ items, name, renderRow }: Props<T>) {
  return (
    <div className="block w-full">
      <div className="p-2">
        <h4 className="text-lg">Current {name}</h4>
        <p className="text-xs opacity-70">
          The following {name.toLowerCase()} will be added to this operator on
          creation
        </p>
      </div>
      <Divider />
      <ItemList<T> items={items} name={name} renderRow={renderRow} />
    </div>
  );
}

function ItemList<T>({ items, name, renderRow }: Props<T>) {
  if (items.length === 0)
    return (
      <div className="p-4">
        <NoDataMessage
          title={`No ${name}`}
          subTitle={`Add or Import new ${name} above.`}
        />
      </div>
    );

  const renderDivider = (index: number) => {
    if (items.length === index + 1) return;
    return <Divider />;
  };

  return (
    <div className="w-full max-h-[300px] overflow-auto">
      {items.map((item, index) => (
        <React.Fragment key={`create-operator-package-${index + 1}`}>
          <div className="inline-flex items-center gap-4 w-full py-2">
            {renderRow(item, index)}
          </div>
          {renderDivider(index)}
        </React.Fragment>
      ))}
    </div>
  );
}
